var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PrivacyPoliciesLayout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('PrivacyPoliciesTab',{attrs:{"privacy-policies":_vm.privacyPolicies},on:{"load-privacy-policies":_vm.loadPrivacyPolicies}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }